// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { rem } from '../../tokens/conversions';
import { background } from '../../tokens/themeColors/background';
import { border } from '../../tokens/themeColors/border';
import { breadcrumbsColors } from './breadcrumbsColors';
export var Breadcrumbs = function(mode) {
    var c = breadcrumbsColors(mode);
    var bg = background(mode);
    var bd = border(mode);
    var override = {
        MuiBreadcrumbs: {
            styleOverrides: {
                ol: {
                    gap: rem(4),
                    '&& *': {
                        color: c.previous.text
                    },
                    '& > *:last-child > *': {
                        color: c.default.text
                    }
                },
                separator: {
                    margin: 0,
                    fontSize: rem(12),
                    lineHeight: rem(16),
                    fontWeight: 500
                },
                li: {
                    fontSize: rem(12),
                    lineHeight: rem(16),
                    fontWeight: 500,
                    padding: rem(4),
                    borderRadius: rem(4),
                    border: "".concat(rem(1), " solid transparent"),
                    '&:not(:last-child):hover': {
                        backgroundColor: bg.state.hover0
                    },
                    '&:not(:last-child):hover *': {
                        color: c.hover.text
                    },
                    '&:not(:last-child):active': {
                        border: "".concat(rem(1), " solid ").concat(bd.actionBold),
                        backgroundColor: 'transparent'
                    },
                    '& > a': {
                        textDecoration: 'none'
                    }
                }
            },
            variants: [
                {
                    props: {
                        size: 'large'
                    },
                    style: {
                        '& .MuiBreadcrumbs-ol': {
                            gap: rem(8)
                        },
                        '& .MuiBreadcrumbs-li': {
                            fontSize: rem(30),
                            lineHeight: rem(38),
                            fontWeight: 600
                        },
                        '& .MuiBreadcrumbs-separator': {
                            fontSize: rem(30),
                            lineHeight: rem(38),
                            fontWeight: 600
                        }
                    }
                }
            ]
        }
    };
    return override;
};

//# sourceMappingURL=Breadcrumbs.js.map